<template>
  <div
    v-if="
      config.name == 1 ||
      config.name == 3 ||
      config.name == 4 ||
      config.name == 'Rectangle' ||
      config.name == 'Square'
    "
    :style="{
      width: '100%',
      height: '100%',
      background: backgroundStyle,
       border:
        (config.strokeWidth || 1) +
        'px solid ' +
        (config.outlineColor || '#000'),
      borderRadius:
        config.name == 3 || config.name == 'Square'
          ? '0'
          : config.borderRadius + 'px' || '0',
    }"
  ></div>
  <div
    v-else-if="config.name == 2 || config.name == 'Circle'"
    :style="{
      width: '100%',
      height: '100%',
      background: backgroundStyle,
      border:
        (config.strokeWidth || 1) +
        'px solid ' +
        (config.outlineColor || '#000'),
      borderRadius: '50%',
    }"
  ></div>
  <div
    v-else-if="config.name == 4 || config.name == 'Triangle'"
    :style="{
      borderBottom: '100px solid ' + (config.fillColor || '#000'),
      borderLeft: '50px solid transparent',
      borderRight: '50px solid transparent',
      borderTop: '0 solid transparent',
      borderWidth: '0 50px 100px 50px',
      borderStyle: 'solid',
      width: '0',
      height: '0',
      position: 'absolute',
      left: 'calc(50% - 50px)',
      top: 'calc(50% - 50px)',
    }"
  ></div>
</template>

<script lang="ts">
export default {
  name: "ClipartWidget",
};
</script>

<script setup lang="ts">
import { computed, defineProps } from "vue";

const props = defineProps<{
  config: any;
}>();

// Function to convert hex to rgba
function hexToRgba(hex: string, alpha: number) {
  let c = hex.replace("#", "");
  if (c.length === 3)
    c = c
      .split("")
      .map((x) => x + x)
      .join("");
  const num = parseInt(c, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
}

// Computed property to determine background style
const backgroundStyle = computed(() => {
  // If there's a bgConfig with gradient, apply gradient
  if (props.config.bgConfig?.gradient) {
    const gradient = props.config.bgConfig.gradient;
    const start = hexToRgba(gradient.startColor, gradient.startColorOpacity);
    const end = hexToRgba(gradient.endColor, gradient.endColorOpacity);

    // Determine gradient direction
    let linearDirection = "to right";
    let radialPosition = gradient.direction || "center";

    switch (gradient.direction) {
      case "left-right":
        linearDirection = "to right";
        break;
      case "right-left":
        linearDirection = "to left";
        break;
      case "top-bottom":
        linearDirection = "to bottom";
        break;
      case "bottom-top":
        linearDirection = "to top";
        break;
      case "top-left-bottom-right":
        linearDirection = "135deg";
        break;
      case "top-right-bottom-left":
        linearDirection = "225deg";
        break;
      case "bottom-left-top-right":
        linearDirection = "45deg";
        break;
      case "bottom-right-top-left":
        linearDirection = "315deg";
        break;
      default:
        linearDirection = "to right";
    }

    if (gradient.type === "linear") {
      return `linear-gradient(${linearDirection}, ${start}, ${end})`;
    } else {
      // radial
      return `radial-gradient(circle at ${radialPosition}, ${start}, ${end})`;
    }
  }

  // If there's a bgConfig with fillColor, use that
  if (props.config.bgConfig?.fillColor) {
    return props.config.bgConfig.fillColor;
  }

  // Fallback to the original fillColor
  return props.config.fillColor || "#000";
});
</script>

<style scoped></style>
